<template lang="pug">
  .d-flex.align-items-center.platforms-tabs
    b-button.p-1.flex-d.left-btn.hide(variant="light", pill, @click="scrollContent('-')", style="z-index:2")
      chevron-left-icon.icon-md
    b-tabs.no-scrollbar.overflow-x#tab-row(nav-class="platform-tabs-flex")
      b-tab(v-for="(platform, index) in allPlatforms", :key="index", :active="active == platform.name", @click="$emit('click:active', platform.name)")
        template(v-slot:title)
          v-icon.mr-2(:name="platform.description", v-if="platform.description", scale="0.9")
          span {{ platform.title }}
    b-button.p-1.flex-d.right-btn(variant="light", pill, @click="scrollContent('+')")
      chevron-right-icon.icon-md
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
const platformController = createNamespacedHelpers('platform')

export default {
  props: {
    active: {
      type: String,
      default: 'all'
    },
    show_all_tab: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...platformController.mapState({
      platforms: state => state.platforms
    }),
    allPlatforms () {
      if(!this.platforms) return []
      let array = this.platforms.slice()
      if(this.show_all_tab){
        array.splice(0, 0, {
          name: 'all',
          title: 'Todas',
          description: 'list'
        })
      }
      return array
    },
  },
  methods: {
    ...mapActions(['platform/all']),
    getPlatforms () {
      if(this.platforms.length) return
      let self = this

      this['platform/all']({
        account_id: self.$route.params.account_id,
        params: { platform: self.active || 'all' },
        callback: res => {
          setTimeout(() => {
            this.hideSideButtons()
          }, 0)
        }
      })
    },
    hideSideButtons () {
      let el = document.getElementById('tab-row')
      if(el.scrollWidth <= el.clientWidth){
        $('.right-btn').addClass('hide')
      }
    },
    scrollContent (direction) {
      $('#tab-row').animate({scrollLeft: direction + '=150'}, 200)
    },
  },
  created () {
    this.getPlatforms()
  },
  mounted() {
    let el = document.getElementById('tab-row')
    el.addEventListener('scroll', function (e) {
      el.scrollLeft == 0 ? $('.left-btn').addClass('hide') : $('.left-btn').removeClass('hide')
      el.scrollWidth <= el.scrollLeft + el.clientWidth ? $('.right-btn').addClass('hide') : $('.right-btn').removeClass('hide')
    })
  },
}
</script>

<style lang="scss">
  .platform-tabs-flex {
    white-space: nowrap;
    flex-wrap: nowrap !important;
    -webkit-overflow-scrolling: touch;
  }
</style>

<style lang="scss" scoped>
  .flex-d {
    display: flex;
  }

  .hide {
    visibility: hidden;
  }

  .platforms-tabs {
    position: relative;


    .left-btn, .right-btn {
      position: absolute;
      z-index: 1;
    }

    .left-btn {
      left: 0;
    }

    .right-btn {
      right: 0;
    }
  }
</style>
